<template>
  <v-container grid-list-md>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="usuario.admin"
          color="yellow"
          class="ml-4 mb-6 mt-4"
          v-on="on"
          >Crear noticia</v-btn
        >
      </template>

      <v-card>
        <v-card-title>
          <span class="headline"> Nueva noticia </span>
        </v-card-title>

        <v-card-text>
          <v-container fill-height>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="noticia.titulo"
                  required
                  label="Título"
                ></v-text-field>
                <v-text-field
                  v-model="noticia.subtitulo"
                  required
                  label="Subtitulo"
                ></v-text-field>
                <v-text-field
                  v-model="noticia.url"
                  label="URL"
                  placeholder="https://"
                ></v-text-field>
                <v-textarea
                  v-model="noticia.descripcion"
                  required
                  label="Texto de la noticia"
                ></v-textarea>
              </v-col>

              <v-col cols="12" sm="12" md="12"> </v-col>
              <v-col cols="12" sm="12" md="12"> </v-col>
              <v-col cols="12" sm="12" md="12">
                <p v-if="imageData != null">{{ imageData.name }}</p>
                <input
                  hidden
                  id="fileInput"
                  type="file"
                  @change="previewImage"
                  accept="image/*"
                />
                <v-btn
                  onclick="document.getElementById('fileInput').click()"
                  required
                  >Subir imagen</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="update"
            >Guardar y cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Test inacabados -->

    <v-layout
      v-if="usuario != null"
      row
      wrap
      class="mb-4"
      style="background: #004100; border-radius: 10px"
    >
      <!-- <Adsense
        data-ad-client="ca-pub-3802200732953296"
        data-ad-slot="2750659910"
      >
      </Adsense> -->
      <v-flex xs12 sm12 m12 class="text-h4 white--text ml-2 mt-2 mr-2"
        ><v-divider></v-divider>Continuar test sin acabar...<v-divider></v-divider
      ></v-flex>
      <v-flex
        class="mt-2"
        xs12
        sm6
        v-for="(item, index) in testsIncompleted"
        :key="index"
      >
        <v-card         style="background: #739673"
 class="mr-2 ml-2 mb-2">
          <v-card-title>
            <v-icon>mdi-note-edit </v-icon>

            <h3>{{ item.preguntas[0].nombreTema }}</h3>
          </v-card-title>
          <v-card-subtitle>
            <h4>{{ item.preguntas[0].nombreTest }}</h4>
          </v-card-subtitle>
          <v-card-text>
            <p>
              <b>Preguntas contestadas: </b> {{ item.questionIndex + 1 }} /
              {{ item.preguntas.length }}
            </p>
            <p>
              <b>Tiempo restante:</b> {{ Math.round(item.tiempo / 60) }}:{{
                item.tiempo % 60
              }}
            </p>
            <p>
              <b>Tipo de correctión:</b>
              {{
                item.tipoExamen == 1
                  ? "Se corrige al final del test"
                  : "Se corrige pregunta a pregunta"
              }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="deleteTestIncompleted(item.id)" color="red">
              Eliminar
            </v-btn>
            <v-btn @click="resumeTest(item)" color="white">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Noticias  -->

    <v-layout
      row
      wrap
      class=""
      style="background: #004100; border-radius: 10px"
    >
      <v-flex xs12 sm12 m12 class="text-h4 white--text mt-2 ml-2 mr-2">
        <v-divider></v-divider> Noticias:<v-divider></v-divider>
      </v-flex>

      <v-flex xs12 sm6 v-for="(item, index) in noticias" :key="index">
        <v-card  style="background: #739673" class="mr-2 ml-2 mb-2 mt-2">
          <v-img max-height="200" :src="item.imagen">
            <v-container>
              <v-layout>
                <v-flex>
                  <span class="white--text headline">{{ item.titulo }}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-card-title>
            <h3>{{ item.subtitulo }}</h3>
          </v-card-title>
          <v-card-text>
            <p>
              {{ item.descripcion }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="usuario.admin"
              @click="deleteNoticia(item.id)"
              color="red"
              
            >
              Eliminar
            </v-btn>
            <v-btn @click="openUrl(item.url)" color="white">
              Mas información
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialogMoreInfo" persistent>
      <v-card>
        <v-card-title> Lorem, ipsum dolor. </v-card-title>
        <v-card-text>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui et
          tenetur officiis commodi optio voluptatibus, saepe facilis, iure error
          molestiae velit dolores mollitia accusantium sed voluptatem sunt
          suscipit. Nam, tenetur!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { firebase, db, auth } from "@/firebase";


export default {
  components: {},
  methods: {
    ...mapActions([
      "cerrarSesion",
      "loadNoticias",
      "saveNoticia",
      "deleteNoticia",
      "deleteTestIncompleted",
      "setLoadingTrue",
      "loadTestsIncompleted",
    ]),
    openUrl(url) {
      if (url.startsWith("http")) {
        window.open(url, "_blank");
      }
    },
    resumeTest(item) {
      if (item.tipoExamen == 1) {
        this.$router.push({
          name: "examen",
          params: {
            resume: true,
            timerCountProp: item.tiempo,
            preguntasProps: item.preguntas,
            questionIndexProps: item.questionIndex,
            respuestasProps: item.respuestas,
            idTestIncompleted: item.id,
          },
        });
      }

      if (item.tipoExamen == 2) {
        this.$router.push({
          name: "examen2",
          params: {
            resume: true,
            timerCountProp: item.tiempo,
            preguntasProps: item.preguntas,
            questionIndexProps: item.questionIndex,
            respuestasProps: item.respuestas,
            idTestIncompleted: item.id,
          },
        });
      }
    },
    previewImage(event) {
      this.uploadValue = 0;
      this.picture = null;
      this.imageData = event.target.files[0];
      this.noticia.imagen = URL.createObjectURL(this.imageData);
      console.log("usuario.foto");
      console.log(this.imageData.name);
    },
    update() {
      if (!this.noticia.url.startsWith("http")) {
        alert("La url está mal");
        return;
      }
      if (this.imageData != null) {
        this.picture = null;
        const storageRef = firebase
          .storage()
          .ref(`${"noticias/" + this.imageData.name}`)
          .put(this.imageData);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
          },
          (error) => {
            console.log(error.message);
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.picture = url;
              this.noticia.imagen = url;
              console.log(this.picture);
              this.saveNoticia(this.noticia);
              this.dialog = false;
            });
          }
        );
      } else {
        this.saveNoticia(this.noticia);
        this.dialog = false;
        this.noticia = {};
      }
    },
  },

  created() {
    if (this.usuario != null) {
      this.loadTestsIncompleted();
    }
    this.loadNoticias();
  },
  mounted(){

  },

  data() {
    return {
      noticia: {},
      dialog: false,
      dialogMoreInfo: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
    };
  },
  computed: {
    ...mapState(["usuario", "noticias", "testsIncompleted", "loading"]),
  },
};
</script>
